// Core
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import { Button, FieldSelect, SectionCard } from "components/AtomsV2";
import { Icon } from "components/ShellV2";
// Redux
import { useSelector } from "react-redux";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";
import { useGetAvailableResourceMetersQuery } from "state/resources/resourcesApiSlice";

function MetersInfo({ data, onUpdate, readOnly, resourceId, startDate, endDate }) {
  const community = useSelector(selectCurrentCommunity);

  const { data: meters = [], isFetching } = useGetAvailableResourceMetersQuery(
    { communityId: community.id, resourceId, startDate, endDate: endDate || undefined },
    { skip: !startDate }
  );

  const { t } = useTranslation(["resources", "common"]);

  const meterOptions = [
    { value: "", label: t("versioning.editor.noneViewOnly", { ns: "common" }) },
    ...meters.map((m) => ({ value: m.id, label: m.identifier })),
  ];

  return (
    <SectionCard id="meters" icon="electric_meter" title={t("single.meters.title")}>
      <p className="text-[12.5px] text-ink-3 leading-[1.5] -mt-2 mb-4">
        {t("single.meters.question")}
      </p>
      <div className="rec-toggle-row">
        <span className="flex-1 text-[13.5px] font-semibold text-ink">
          {t("single.meters.identifier")}
        </span>
        <div className="min-w-[220px]">
          <FieldSelect
            value={data?.id ?? ""}
            options={meterOptions}
            onChange={(v) => onUpdate({ meterId: v || null })}
            disabled={readOnly || isFetching || !startDate}
          />
        </div>
        {!readOnly && data?.id && (
          <Button
            variant="ghost"
            aria-label={t("single.meters.remove_assignment")}
            disabled={isFetching || !startDate}
            onClick={() => onUpdate({ meterId: null })}
          >
            <Icon name="link_off" />
          </Button>
        )}
      </div>
    </SectionCard>
  );
}

MetersInfo.defaultProps = {
  data: {
    id: "",
    identifier: "",
  },
  onUpdate: () => {},
  readOnly: false,
  endDate: null,
};
MetersInfo.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    identifier: PropTypes.string,
  }),
  onUpdate: PropTypes.func,
  readOnly: PropTypes.bool,
  resourceId: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
};

export default MetersInfo;
